// @ts-nocheck
import React from "react";

import AccessTimeIcon from "@material-ui/icons/AccessTime";
import CancelIcon from "@material-ui/icons/Cancel";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import PrintOutlinedIcon from "@material-ui/icons/PrintOutlined";
import CheckIcon from "@material-ui/icons/Check";

import { useRequirement } from "../../../hooks/requirement";
import { isPlanoComoEssencial, seloApostila } from "../../../helpers/process.helper";

import {
  Corpo,
  Selo,
  Titulo,
  AvisoLink,
  Aviso,
  Blocos,
  Bloco,
  Progresso,
  BotaoLink,
  LinkTexto,
  Secao,
  Itens,
  Item,
  Etiqueta,
  Recolhido,
  Ajuda,
} from "./ui";

// "Original Certidão de nascimento de Fernanda, atualizada"
export const descricaoDocumento = (doc, requerente) =>
  [
    [doc?.format, doc?.from_who ? doc.from_who.replace("applicant", requerente) : null].filter(Boolean).join(", de "),
    doc?.specification,
  ]
    .filter(Boolean)
    .join(" · ");

// Plano 2026: a CJ pode pedir a emissão ao cartório (custas do cliente) e o
// cliente também pode emitir sozinho; por isso o fluxo de emissão só vale
// enquanto o documento está pendente ou já tem pedido/emissão.
const fluxoEmissao = (doc, sale) => {
  const custasPeloCliente = !!sale?.emission_paid_by_client;
  return (
    sale?.is_fmd &&
    doc?.enabled_to_fmd === 1 &&
    (!custasPeloCliente || doc?.status === "PENDING" || doc?.form_filled === 1 || !!doc?.emission)
  );
};

// Emissão já pedida (formulário enviado ou registro de emissão).
const emEmissao = (doc) => doc?.form_filled === 1 || !!doc?.emission;

// Texto curto do estado da emissão antiga (process_service_documents.emission).
const estadoEmissao = (doc) => {
  const status = doc?.emission?.status;
  if (!status || (doc?.form_filled === 1 && status === "Aguardando dados")) return "Recebemos seus dados. Vamos consultar o cartório.";
  const textos = {
    "Em busca": "Estamos procurando o registro no cartório.",
    "Aguardando Requerimento": "O cartório pediu um requerimento assinado.",
    "Aguardando requerimento do cliente": "O cartório pediu um requerimento assinado.",
    "Orçamento solicitado": "Pedimos o orçamento ao cartório.",
    "Aguardando pagamento": "O orçamento chegou: falta pagar as custas.",
    "Pedido pago pelo cliente": "Aguardando o cartório confirmar o pagamento.",
    "Pagamento confirmado pelo cartório": "O cartório está emitindo a certidão.",
    "Aguardando retirada": "A certidão está saindo do cartório.",
    "Aguardando código de rastreio": "A certidão foi despachada; o rastreio sai em breve.",
    "Certidão Chegou": "A certidão chegou; estamos conferindo.",
    "Certidão chegou": "A certidão chegou; estamos conferindo.",
    "Concluído": "A certidão já está com a gente.",
  };
  return textos[status] || status;
};

export default function Documentacao({ process, emissoes, controllerModal, FMDModal, apensadoCompleto }) {
  const { addRequirement } = useRequirement();
  const documentos = process?.service_documents || [];
  const sale = process?.sale;
  const requerente = process?.applicant?.name;
  const essencial = isPlanoComoEssencial(sale?.family_plan);

  const abrir = (doc, modal) => {
    addRequirement({
      ...doc,
      applicant: requerente,
      identifier: process?.identifier,
      is_fmd: sale?.is_fmd,
      emission_paid_by_client: sale?.emission_paid_by_client,
      family_plan: sale?.family_plan,
      open: true,
      proxy_form_path: process?.proxy_form_path,
      process_id: process?.id,
      proxy_path: process?.proxy_path,
      service_code: process?.service_code,
      type: process?.type,
    });
    modal && modal();
  };

  const necessarios = documentos.filter((d) => d?.status !== "NOT_REQUIRED");
  const recebidos = documentos.filter((d) => d?.status === "ARRIVED_SUCCESSFULLY");
  const dispensados = documentos.filter((d) => d?.status === "NOT_REQUIRED");
  const emitindo = documentos.filter((d) => d?.status === "PENDING" && fluxoEmissao(d, sale) && emEmissao(d));
  const voceEnvia = documentos.filter(
    (d) => (d?.status === "PENDING" || d?.status === "ARRIVED_WRONG") && !emitindo.includes(d)
  );

  // Pendências do cliente na aba Emissões deste PT.
  const pendenciasEmissao = (emissoes || []).filter((e) => e?.pt === process?.service_code && e?.vez === "cliente");

  const percentual = necessarios.length ? (recebidos.length / necessarios.length) * 100 : Number(process?.documents_completed) || 0;
  const tudoRecebido = voceEnvia.length === 0 && emitindo.length === 0;

  return (
    <Corpo>
      {tudoRecebido ? (
        <>
          <Selo tipo="equipe" />
          <Titulo>Todos os documentos chegaram</Titulo>
          <p className="desc">
            {apensadoCompleto
              ? "A documentação deste pedido está completa. Ele aguarda os pedidos apensados completarem para seguir junto para a análise."
              : "Recebemos tudo o que estava na lista. O pedido segue para a análise."}
          </p>
        </>
      ) : (
        <>
          <Selo tipo="cliente" />
          <Titulo>Envie os documentos da lista</Titulo>
          <p className="desc">
            {essencial
              ? "Reúna os documentos abaixo, apostile os que pedirem e mande tudo num envelope só, com o PT escrito, pelos Correios."
              : "Reúna os documentos abaixo e mande tudo num envelope só, com o PT escrito, pelos Correios. A apostila fica com a gente."}
          </p>
        </>
      )}

      {pendenciasEmissao.length > 0 && (
        <AvisoLink href="/emissoes">
          <i />
          <span>
            <b>Também com você:</b>{" "}
            {pendenciasEmissao.length === 1
              ? pendenciasEmissao[0]?.etapa === "requerimento"
                ? "enviar o requerimento da certidão em emissão"
                : "pagar as custas da certidão em emissão"
              : `${pendenciasEmissao.length} certidões em emissão esperam por você`}
          </span>
          <ChevronRightIcon style={{ marginLeft: "auto", color: "var(--cinza-80)" }} />
        </AvisoLink>
      )}

      <Blocos>
        <Bloco rotulo="Quanto demora">Depende de você</Bloco>
        <Bloco rotulo="Depois que chegar">Conferimos em até 5 dias úteis</Bloco>
      </Blocos>

      <Progresso
        rotulo={`${recebidos.length} de ${necessarios.length} documento${necessarios.length === 1 ? "" : "s"} recebido${recebidos.length === 1 ? "" : "s"}`}
        percentual={percentual}
      />

      {!tudoRecebido && (
        <BotaoLink href="/impressao" target="_blank" onClick={() => abrir(process)}>
          <PrintOutlinedIcon />
          Imprimir lista e etiqueta do envelope
        </BotaoLink>
      )}

      {voceEnvia.length > 0 && (
        <>
          <Secao>Você envia · faltam {voceEnvia.length}</Secao>
          <Itens>
            {voceEnvia.map((doc) => {
              const reprovado = doc?.status === "ARRIVED_WRONG";
              const procuracao = doc?.name === "Procuração assinada";
              const pedirEmissao = fluxoEmissao(doc, sale) && !emEmissao(doc);
              const selo = seloApostila(doc?.name, sale?.family_plan);

              return (
                <Item
                  key={`${doc?.reference_id}-${doc?.name}`}
                  tipo={reprovado ? "erro" : pedirEmissao ? "cliente" : procuracao ? "neutro" : "cliente"}
                  icone={reprovado ? <CancelIcon /> : procuracao ? <EditOutlinedIcon /> : <DescriptionOutlinedIcon />}
                  titulo={doc?.name}
                  descricao={descricaoDocumento(doc, requerente)}
                >
                  {reprovado ? (
                    <>
                      <span className="motivo">
                        <b>Não aprovado.</b> {doc?.observation || "Veja o que aconteceu e envie de novo."}
                      </span>
                      <LinkTexto as="button" type="button" onClick={() => abrir(doc, controllerModal)}>
                        Veja o que aconteceu <ChevronRightIcon />
                      </LinkTexto>
                    </>
                  ) : pedirEmissao ? (
                    <>
                      <Etiqueta tipo="equipe">A CJ emite</Etiqueta>
                      <LinkTexto as="button" type="button" onClick={() => abrir(doc, FMDModal)}>
                        Preencher dados da emissão <ChevronRightIcon />
                      </LinkTexto>
                      {sale?.emission_paid_by_client && (
                        <LinkTexto as="button" type="button" onClick={() => abrir(doc, controllerModal)}>
                          Prefiro emitir eu mesmo <ChevronRightIcon />
                        </LinkTexto>
                      )}
                    </>
                  ) : procuracao ? (
                    <LinkTexto as="button" type="button" onClick={() => abrir(doc, controllerModal)}>
                      {process?.proxy_path ? "Edite e baixe sua procuração" : "Preencher procuração"} <ChevronRightIcon />
                    </LinkTexto>
                  ) : (
                    <>
                      <Etiqueta tipo={selo.tipo === "sim" ? "cliente" : selo.tipo === "cj" ? "equipe" : "neutro"}>{selo.texto}</Etiqueta>
                      <LinkTexto as="button" type="button" onClick={() => abrir(doc, controllerModal)}>
                        Saiba sobre o formato e como emitir <ChevronRightIcon />
                      </LinkTexto>
                    </>
                  )}
                </Item>
              );
            })}
          </Itens>
        </>
      )}

      {emitindo.length > 0 && (
        <>
          <Secao>A CJ está emitindo · {emitindo.length}</Secao>
          <Itens>
            {emitindo.map((doc) => (
              <Item
                key={`${doc?.reference_id}-${doc?.name}`}
                tipo="ok"
                icone={<AccessTimeIcon />}
                titulo={doc?.name}
                descricao={estadoEmissao(doc)}
              >
                {doc?.emission?.tracking_code && <small>Rastreio: {doc.emission.tracking_code}</small>}
                <LinkTexto href="/emissoes">
                  Ver em Emissões <ChevronRightIcon />
                </LinkTexto>
              </Item>
            ))}
          </Itens>
        </>
      )}

      {recebidos.length + dispensados.length > 0 && (
        <Recolhido
          rotulo={`${recebidos.length} documento${recebidos.length === 1 ? "" : "s"} já recebido${recebidos.length === 1 ? "" : "s"}${
            dispensados.length ? ` · ${dispensados.length} não necessário${dispensados.length === 1 ? "" : "s"}` : ""
          }`}
        >
          <Itens>
            {[...recebidos, ...dispensados].map((doc) => (
              <Item
                key={`${doc?.reference_id}-${doc?.name}`}
                tipo={doc?.status === "NOT_REQUIRED" ? "neutro" : "ok"}
                icone={doc?.status === "NOT_REQUIRED" ? <DescriptionOutlinedIcon /> : <CheckIcon />}
                titulo={doc?.name}
                descricao={doc?.status === "NOT_REQUIRED" ? "Não é necessário neste pedido" : descricaoDocumento(doc, requerente)}
              />
            ))}
          </Itens>
        </Recolhido>
      )}

      {!tudoRecebido && (
        <Ajuda
          titulo="Como enviar"
          passos={[
            "Reúna os originais da lista “Você envia”.",
            essencial ? "Apostile só os que têm o selo “Precisa de apostila”." : "Não precisa apostilar: a nossa equipe cuida disso.",
            <>
              Escreva <b>{process?.service_code}</b> no envelope e mande pelos Correios.
            </>,
          ]}
        />
      )}

      {essencial && !tudoRecebido && (
        <Aviso tipo="cliente">
          <b>Envie os documentos já apostilados</b>
          <p>Documento sem apostila não entra no processo e volta para você.</p>
        </Aviso>
      )}
    </Corpo>
  );
}
